import { getServerUrl } from '../../utils/serverUrl';

export async function postToServer(url: string, data: any) {
  const serverUrl = getServerUrl(url);
  const res = await fetch(serverUrl, {
    method: "post",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ...data,
    }),
  });
  return await res.json();
}
